import React, { useContext } from "react";
import Brain from "..//assets/brain (1).svg";
import { Link } from "react-router-dom";
import "./nav.css";
import { AuthContext } from "../../AuthContext";
import ImageComponent from "../../pages/articales/ImageComponent";
const Navv = () => {
  const authContext = useContext(AuthContext);
  return (
    <nav
      id="nav"
      style={{ backgroundColor: "#fff" }}
      className="navbar border-bottom border-opacity-25 border-secondary border-2 shadow  navbar-expand-lg 
     navbar-light bg-light"
    >
      <div className="container w-75   ">
        <div className="d-flex   w-100 justify-content-between  align-items-center">
          <Link className="navbar-brand  " to='/'>
            <img src={Brain} className="im" style={{width:"75px"}} alt="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="true"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav  d-flex justify-content-between align-items-center  me-auto mb-2 mb-lg-0">
            <li className="nav-item px-3 ">
              <Link className="nav-link  active " aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item px-3">
            { authContext.auth && authContext.auth.user ?  <Link className="nav-link " to="chatbot">
                Chatbot
              </Link>: <Link className="nav-link " to="/welcome">
                Chatbot
              </Link>}
            </li>
            <li className="nav-item px-3">
              <Link className="nav-link " style={{width:"max-content"}} to="/articles">
              Psychiatric Illness
              </Link>
            </li>
            <li className="nav-item px-3">
            { authContext.auth && authContext.auth.user ?  <Link className="nav-link " to="test">
                Test
              </Link>: <Link className="nav-link " to="/welcom2">
                Test
              </Link>}
            </li>
             {authContext.auth&& authContext.auth.token ? (
              <li className="nav-item ">
                <Link to='/account'
                  className=" rounded-circle mb-3 me-4 mt-3 d-flex align-items-center justify-content-center"
                  style={{
                    width:"55px",
                    height:"55px",
                    color: "blue",
                    fontSize: "33px",
                    fontWeight: "bold",
                  }}
                >
                  <ImageComponent base64String={authContext?.auth?.picture} height={"100%"} border={'100%'}/>
                </Link>
              </li>
            ) : (
              <li className="nav-item ">
                <button
                  className="btn main-color  rounded-pill  px-5  py-1  "
                  type="submit"
                >
                  <Link className="text-white " to="/login">
                    Login
                  </Link>
                </button>
              </li>
            )}
              {authContext.auth.role==="Admin"?<li className="nav-item ">
                <button
                  className="btn main-color  rounded-pill  px-5  py-1  "
                  type="submit"
                >
                  <Link className="text-white " to="/articleDashboard">
                    Dashboard
                  </Link>
                </button>
              </li>:''}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navv;
